import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "form-city-terminal" }
const _hoisted_2 = { class: "wrap-content" }
const _hoisted_3 = { class: "content" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", {
  class: "pi pi-plus mr-2",
  style: {"font-size":"16px"}
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Tambah Terminal")
const _hoisted_6 = [
  _hoisted_4,
  _hoisted_5
]
const _hoisted_7 = {
  key: 0,
  class: "pt-16 overflow-x-auto sm:content-table sm:pt-0"
}
const _hoisted_8 = { class: "table-terminals detail-city" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("th", null, "Nama"),
  /*#__PURE__*/_createElementVNode("th", null, "Kode"),
  /*#__PURE__*/_createElementVNode("th", null, "Jenis"),
  /*#__PURE__*/_createElementVNode("th", null, "Titik Peta"),
  /*#__PURE__*/_createElementVNode("th", null, "Keterangan")
], -1)
const _hoisted_10 = { class: "" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("i", {
  class: "pi pi-times font-black text-xs",
  style: {"color":"#FF5E5E"}
}, null, -1)
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = { class: "flex grouping-button gap-2" }
const _hoisted_15 = /*#__PURE__*/_createTextVNode("Kembali")
const _hoisted_16 = /*#__PURE__*/_createTextVNode("Simpan")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SelectFetch = _resolveComponent("SelectFetch")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Card = _resolveComponent("Card")!
  const _component_ModalTerminal = _resolveComponent("ModalTerminal")!
  const _component_HjpConfirmationModal = _resolveComponent("HjpConfirmationModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Card, { class: "card-no-shadow card" }, {
      title: _withCtx(() => [
        _createElementVNode("h4", null, _toDisplayString(_ctx.isEdit ? 'Edit' : 'Tambah') + " Kota & Terminal", 1)
      ]),
      content: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_SelectFetch, {
              modelValue: _ctx.selectCity,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectCity) = $event)),
              "input-id": "class-input",
              endpoint: "/management/v1/MsCity",
              fieldLabel: (v) => v.CityName,
              fieldValue: 'CityCode',
              clearable: false,
              searchFields: ['query'],
              placeholder: `Pilih Kota`
            }, null, 8, ["modelValue", "fieldLabel"]),
            _withDirectives(_createElementVNode("div", {
              class: "color-blue-1 text-center font-extrabold cursor-pointer mt-4",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showModal = true))
            }, _hoisted_6, 512), [
              [_vShow, _ctx.selectCity]
            ])
          ]),
          (_ctx.selectCity)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createElementVNode("table", _hoisted_8, [
                  _hoisted_9,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.itemsTerminal.filter((x) => !x.IsDeleted), (terminal, i) => {
                    return (_openBlock(), _createElementBlock("tr", { key: i }, [
                      _createElementVNode("td", null, _toDisplayString(terminal.Name), 1),
                      _createElementVNode("td", null, _toDisplayString(terminal.Code ?? '-'), 1),
                      _createElementVNode("td", null, _toDisplayString(terminal.Type), 1),
                      _createElementVNode("td", null, _toDisplayString(`${terminal.Latitude}, ${terminal.Longitude}`), 1),
                      _createElementVNode("td", null, _toDisplayString(terminal.Description), 1),
                      _createElementVNode("td", _hoisted_10, [
                        _createElementVNode("div", {
                          class: "inline-flex rounded-full cursor-pointer justify-center",
                          style: {"background-color":"#FFEDED","padding":"7px 10px 7px 10px"},
                          onClick: ($event: any) => (_ctx.deleteItemTerminal(terminal))
                        }, _hoisted_13, 8, _hoisted_11)
                      ])
                    ]))
                  }), 128))
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_14, [
          _createVNode(_component_Button, {
            class: "btn-back",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onBack()))
          }, {
            default: _withCtx(() => [
              _hoisted_15
            ]),
            _: 1
          }),
          _withDirectives(_createVNode(_component_Button, {
            onClick: _ctx.submit,
            class: "btn-primary"
          }, {
            default: _withCtx(() => [
              _hoisted_16
            ]),
            _: 1
          }, 8, ["onClick"]), [
            [_vShow, _ctx.itemsTerminal.filter((x) => !x.IsDeleted).length > 0]
          ])
        ])
      ]),
      _: 1
    }),
    (_ctx.selectCity)
      ? (_openBlock(), _createBlock(_component_ModalTerminal, {
          key: 0,
          show: _ctx.showModal,
          onHideDialog: _ctx.hideDialog,
          dataCity: _ctx.selectCity,
          onOnSubmit: _ctx.submitModal,
          listTerminalExist: _ctx.itemsTerminal.filter((x) => !x.IsDeleted)
        }, null, 8, ["show", "onHideDialog", "dataCity", "onOnSubmit", "listTerminalExist"]))
      : _createCommentVNode("", true),
    _createVNode(_component_HjpConfirmationModal, {
      show: _ctx.modalConfirmation.show,
      imgContent: _ctx.modalConfirmation.imgContent,
      title: _ctx.modalConfirmation.title,
      subTitle: _ctx.modalConfirmation.subTitle,
      btnSubmitTitle: _ctx.modalConfirmation.btnSubmitTitle,
      onOnSubmit: _ctx.doSubmit,
      onHideDialog: _ctx.hideConfirmModal
    }, null, 8, ["show", "imgContent", "title", "subTitle", "btnSubmitTitle", "onOnSubmit", "onHideDialog"])
  ]))
}